"use strict";
(() => {
  var s = "ADD_TO_CART_ERROR",
    c = "ADD_TO_CART";
  var p = (e) => e.split("/").pop(),
    d = {
      default: {
        Harvey: "43192163008665",
        Donna: "42941836198041",
        Katrina: "42941837344921",
        MikeL: "42941825679513",
        Nina: "43454665261209",
        Louis: "43466405380249",
        Amelie: "42941835378841",
        Jessica: "42941837115545",
        Paula: "43475298451609",
        Marie: "42941839016089",
        MikeR: "42941825679513",
        Katrina2: "56220850782590",
        MikeL2: "56262952386942",
        MikeR2: "56262952386942",
        Amy: "56258480865662",
        Donna2: "56257775272318",
      },
      ch: {
        Harvey: "43192163008665",
        Donna: "42941836198041",
        Katrina: "42941837344921",
        MikeL: "42941825679513",
        Nina: "43454665261209",
        Louis: "43466405380249",
        Amelie: "42941835378841",
        Jessica: "42941837115545",
        Paula: "43475298451609",
        Marie: "42941839016089",
        MikeR: "42941825679513",
        Katrina2: "56220850782590",
        MikeL2: "56262952386942",
        MikeR2: "56262952386942",
        Amy: "56258480865662",
        Donna2: "56257775272318",
      },
      eu: {
        Harvey: "42753242661054",
        Donna: "42481184768190",
        Katrina: "42481195745470",
        MikeL: "42481218879678",
        Nina: "43092670546110",
        Louis: "43326118854846",
        Amelie: "42481180410046",
        Jessica: "42481180410046",
        Paula: "43099401322686",
        Marie: "42481212653758",
        MikeR: "42481218879678",
        Katrina2: "55720086176124",
        MikeL2: "55759630991740",
        MikeR2: "55759630991740",
        Amy: "55756018712956",
        Donna2: "55752728150396",
      },
      it: {
        Harvey: "44647556808892",
        Donna: "44647504871612",
        Katrina: "44647505133756",
        MikeL: "44647505199292",
        Nina: "44647579975868",
        Louis: "44647599112380",
        Amelie: "44647504904380",
        Jessica: "44647504969916",
        Paula: "44647580041404",
        Marie: "44647505100988",
        MikeR: "44647505199292",
        Katrina2: "45179500298428",
        MikeL2: "45213508632764",
        MikeR2: "45213508632764",
        Amy: "45210681475260",
        Donna2: "45210168459452",
      },
      at: {
        Harvey: "55268618174843",
        Donna: "55268556407163",
        Katrina: "55268556800379",
        MikeL: "55268557226363",
        Nina: "55268651499899",
        Louis: "55268675387771",
        Amelie: "55268556439931",
        Jessica: "55268556669307",
        Paula: "55268655595899",
        Marie: "55268556964219",
        MikeR: "55268557226363",
        Katrina2: "55730125177211",
        MikeL2: "55748334387579",
        MikeR2: "55748334387579",
        Amy: "55746617213307",
        Donna2: "55746211119483",
      },
      fr: {
        Harvey: "52232076263793",
        Donna: "52232031109489",
        Katrina: "52232031207793",
        MikeL: "52232031371633",
        Nina: "52232097825137",
        Louis: "52232118763889",
        Amelie: "52232030945649",
        Jessica: "52232031175025",
        Paula: "52232103231857",
        Marie: "52232031273329",
        MikeR: "52232031371633",
        Katrina2: "55789231210865",
        MikeL2: "62368756302193",
        MikeR2: "62368756302193",
        Amy: "62366559666545",
        Donna2: "62366281728369",
      },
      nl: {
        Harvey: "44712062976053",
        Donna: "44712065859637", // Donna2
        Katrina: "NL_KATRINA_PLACEHOLDER",
        MikeL: "NL_MIKEL_PLACEHOLDER",
        Nina: "NL_NINA_PLACEHOLDER",
        Louis: "NL_LOUIS_PLACEHOLDER",
        Amelie: "NL_AMELIE_PLACEHOLDER",
        Jessica: "NL_JESSICA_PLACEHOLDER",
        Paula: "NL_PAULA_PLACEHOLDER",
        Marie: "NL_MARIE_PLACEHOLDER",
        MikeR: "NL_MIKER_PLACEHOLDER",
        Katrina2: "NL_KATRINA2_PLACEHOLDER",
        MikeL2: "NL_MIKEL2_PLACEHOLDER",
        MikeR2: "NL_MIKER2_PLACEHOLDER",
        Amy: "NL_AMY_PLACEHOLDER",
        Donna2: "44712065859637",
      },
    },
    u = (e) => {
      let r = crypto.randomUUID();
      e.preview && r && localStorage.setItem(r, e.preview);
      let a = e.items.map((t) => {
        let o = { _set_id: r };
        return (
          t.omitColor || (o.Color = t.color || e.color),
          { quantity: t.quantity, id: p(t.shopifyId), properties: o }
        );
      });
      d[e.store][e.model] &&
        a.push({
          quantity: 1,
          id: d[e.store][e.model],
          properties: {
            _link: e.compositionUrl || "",
            _set_id: r,
            _title: e.model,
            _price: "0",
            _set: r,
          },
        }),
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: a }),
        })
          .then(async (t) => {
            if (!t.ok) {
              let i =
                (await t.json().catch(() => ({})))?.description ||
                t.statusText ||
                "Unknown error";
              throw (
                (a.forEach((n) => console.warn(` - Variant ID: ${n.id}`)),
                window.parent.postMessage(
                  {
                    type: s,
                    payload: {
                      error: i,
                      failedItems: a.map(({ id: n, quantity: l }) => ({
                        id: n,
                        quantity: l,
                      })),
                    },
                  },
                  "*"
                ),
                new Error(i))
              );
            }
            return t.json();
          })
          .then(() => {
            let t = window.location.pathname.split("/")[1] ?? "",
              i = ["en", "de", "fr", "it"].includes(t) ? `/${t}` : "";
            window.location.href = `${i}/cart`;
          })
          .catch(console.error);
    },
    M = (e) => {
      if (e?.data?.type)
        try {
          let r = e.data;
          r.type === c && u(r.payload);
        } catch (r) {
          console.error(r);
        }
    };
  window.addEventListener("message", M, !1);
})();
